import React, { useContext, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { Context } from "../../../../../store/store";
import AttributesPicker from "../../components/attributes-picker";
import { Button } from "./../../components";
import {
  getAvailableAttributes,
  saveAttributes,
  testHasRegularAttributes,
} from "../../utils";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { BottomBar } from "../../components/bottom-bar";
import { useUrlState } from "../../hooks";

function TestSpecialAttributes() {
  const history = useHistory();
  const { t } = useTranslation();
  const { module: currentModule, sessionId } = useUrlState();
  const [state, dispatch] = useContext(Context);
  const { publicTest } = state;

  const [currentAttributes, setCurrentAttributes] = useState({});
  const [canGoNext, setCanGoNext] = useState(false);

  const availableAttributes = useMemo(
    () => getAvailableAttributes(publicTest, true),
    [publicTest]
  );

  const hasRegularAttributes = useMemo(
    () => testHasRegularAttributes(publicTest),
    [publicTest]
  );

  const onChangeHandler = attributes => {
    setCanGoNext(availableAttributes.every(attr => !!attributes[attr]));
    setCurrentAttributes(attributes);
  };

  const onFinishTestButtonClick = () => {
    setCanGoNext(false);
    saveAttributes({
      publicTest,
      sessionId,
      currentAttributes,
      state,
      dispatch,
      history,
      currentModule,
    });
  };

  return (
    <div className="tg_page tg_page-layout page test-special-attributes-page">
      <div className="tg_main">
        <div
          className="tg_attributes-selection-html"
          dangerouslySetInnerHTML={{
            __html: publicTest?.attributeSelectionHtml || "",
          }}
        />
        <AttributesPicker
          publicTest={publicTest}
          isSpecialAttributes={true}
          onChangeHandler={onChangeHandler}
          availableAttributes={availableAttributes}
        />
      </div>
      <div className="tg_column">
        <Button onClick={onFinishTestButtonClick} large disabled={!canGoNext}>
          {hasRegularAttributes
            ? t("frontend.test.nextTestSetButtonText", "Next")
            : t("frontend.test.showResultsButtonText", "Show Results")}
        </Button>
      </div>
      <BottomBar />
    </div>
  );
}

export default TestSpecialAttributes;
